import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const API_URL = `${API_HOST}/api/linkBlockDeepLink`;

function* searchLinkBlockDeepLinks() {
  yield takeEvery(actions.SEARCH_LINK_BLOCK_APP_DEEP_LINKS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error, 'linkBlockAppDeepLink');
    } finally {
      yield put({ type: actions.SEARCH_LINK_BLOCK_APP_DEEP_LINKS_ENDED });
    }
  });
}

function* createLinkBlockDeepLink() {
  yield takeEvery(actions.CREATE_LINK_BLOCK_APP_DEEP_LINK, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error, 'linkBlockAppDeepLink');
    } finally {
      yield put({ type: actions.CREATE_LINK_BLOCK_APP_DEEP_LINK_ENDED });
    }
  });
}

function* updateLinkBlockDeepLink() {
  yield takeEvery(actions.UPDATE_LINK_BLOCK_APP_DEEP_LINK, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error, 'linkBlockAppDeepLink');
    } finally {
      yield put({ type: actions.UPDATE_LINK_BLOCK_APP_DEEP_LINK_ENDED });
    }
  });
}

function* generateLinkBlockDeepLink() {
  yield takeEvery(actions.GENERATE_LINK_BLOCK_APP_DEEP_LINK, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], API_URL + '/generate', formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error, 'linkBlockAppDeepLink');
    } finally {
      yield put({ type: actions.GENERATE_LINK_BLOCK_APP_DEEP_LINK_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createLinkBlockDeepLink),
    fork(searchLinkBlockDeepLinks),
    fork(updateLinkBlockDeepLink),
    fork(generateLinkBlockDeepLink),
  ]);
}
